import { JSX } from 'react';

import {
  BonusIcon,
  CircleRubleIcon,
  PercentIcon,
  TTranslator,
} from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { EPromoValueType } from 'types';

export const generatePromoCodeName = (): string => {
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const length = Math.floor(Math.random() * 9) + 4; // от 4 до 12 символов
  let result = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }

  return result;
};

export const getValuePresentIcon = (
  typePresent: EPromoValueType | null,
  currency: { value: string; sign: string }
): JSX.Element | undefined | string => {
  switch (typePresent) {
    case EPromoValueType.DISCOUNT:
      return <PercentIcon color="secondary" size="m" />;
    case EPromoValueType.DEPOSIT:
      if (currency.sign === '₽') {
        return <CircleRubleIcon color="secondary" size="m" />;
      }
      return currency.sign;
    case EPromoValueType.BONUS:
      return <BonusIcon color="secondary" size="m" />;
    default:
      return undefined;
  }
};

export const getValuePresentTitle = (
  t: TTranslator<TLocalesKeys>,
  typePresent: EPromoValueType | null
): string => {
  switch (typePresent) {
    case EPromoValueType.DISCOUNT:
      return t('promo.present.value.title');
    case EPromoValueType.DEPOSIT:
      return t('cashback.fill.sum');
    case EPromoValueType.BONUS:
      return t('cashback.fill.sum');
    default:
      return t('promo.present.value');
  }
};
